export enum InsurancePlanLevelEnum {
    NoPlanLevel = 'None',
    Individual = 'Individual',
    Family = 'Family'
}
